import { render, staticRenderFns } from "./ResumeIntention.vue?vue&type=template&id=2daacba9&scoped=true"
import script from "./ResumeIntention.vue?vue&type=script&lang=js"
export * from "./ResumeIntention.vue?vue&type=script&lang=js"
import style0 from "./ResumeIntention.vue?vue&type=style&index=0&id=2daacba9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daacba9",
  null
  
)

export default component.exports